import {
  ErpConfigsService,
  ErpIntegrationService,
  IntegrationsService,
} from "@common/client"
import { makeAxiosMutation, makeNoArgsQuery } from "./utils"

// Integration credentials
export const integrationCredentialsKey = ["integrationCredentials"] as const
export const integrationCredentialsForTenantKey = (tenantId: string) =>
  ["integration-credentials-for-tenant", tenantId] as const

// ERP config
export const erpConfigKey = ["erp-config"] as const

export const erpConfigQuery = makeNoArgsQuery({
  serviceCall: ErpIntegrationService.getErpConfig,
  queryKey: erpConfigKey,
})

export const erpConfigIdsKey = (tenantId: string) =>
  ["erp-config-ids", tenantId] as const

export const erpConfigDetailKey = (id: string) => ["erp-config", id] as const

export const useCreateIntegrationCredentialMutation = makeAxiosMutation({
  serviceCall:
    IntegrationsService.createIntegrationCredentialsWithPlaintextPassword,
  invalidates: ({ tenant_id }) => [
    integrationCredentialsKey,
    integrationCredentialsForTenantKey(tenant_id),
  ],
})

export const useUpdateIntegrationCredentialMutation = makeAxiosMutation({
  serviceCall:
    IntegrationsService.updateIntegrationCredentialsWithPlaintextPassword,
  invalidates: ({ tenant_id }) => [
    integrationCredentialsKey,
    integrationCredentialsForTenantKey(tenant_id),
  ],
})

export const useDeleteIntegrationCredentialMutation = makeAxiosMutation({
  serviceCall: IntegrationsService.deleteIntegrationCredentialByTenant,
  invalidates: ({ tenant_id }) => [
    integrationCredentialsKey,
    integrationCredentialsForTenantKey(tenant_id),
  ],
})

export const useCreateErpConfigMutation = makeAxiosMutation({
  serviceCall: ErpConfigsService.createErpConfig,
  invalidates: ({ tenant_id }) => [erpConfigIdsKey(tenant_id)],
})

export const useUpdateErpConfigMutation = makeAxiosMutation({
  serviceCall: ErpConfigsService.updateErpConfig,
  invalidates: ({ tenant_id, id }) => [
    erpConfigIdsKey(tenant_id),
    erpConfigDetailKey(id),
  ],
})

export const useDeleteErpConfigMutation = makeAxiosMutation({
  serviceCall: ErpConfigsService.deleteErpConfig,
  invalidates: ({ tenant_id }) => [erpConfigIdsKey(tenant_id)],
})
